import { Component, OnInit } from '@angular/core';
import {MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-agregar-insumo-dialog',
  templateUrl: './agregar-insumo-dialog.component.html',
  styleUrls: ['./agregar-insumo-dialog.component.scss', '../../common/agris-common-styles.scss']
})
export class AgregarInsumoDialogComponent implements OnInit {

  disabledAddToExistente = false;

  constructor(public dialogRef: MdDialogRef<AgregarInsumoDialogComponent>) { }

  ngOnInit() {
  }

  onSubmit(str): void {
    this.dialogRef.close(str);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-detalle-insumo-page/agregar-insumo-dialog/agregar-insumo-dialog.component.ts